var _path;
import * as React from "react";
function SvgArrowUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.505 26.535c-.66.661-1.73.661-2.383 0a1.687 1.687 0 010-2.383l6.117-6.117-24.052-.007a2.811 2.811 0 00-2.812 2.813v11.811c0 .935-.753 1.687-1.688 1.687A1.683 1.683 0 012 32.652V20.841a6.187 6.187 0 016.187-6.187h24.052l-6.117-6.117a1.68 1.68 0 010-2.383c.66-.654 1.73-.661 2.383 0l9 8.992c.66.66.66 1.73 0 2.383l-9 9.006z"
  })));
}
export default SvgArrowUpRight;